import React, { Fragment } from 'react'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import 'react-lazy-load-image-component/src/effects/blur.css'
import MediaQuery from 'react-responsive'

const ganhePontos = 'https://ltm-ragnarok-tenants-prod-40455-webapp.s3.amazonaws.com/static/media/Banner_duvidas_pontos_desktop.png'
const ganhePontosMobile = 'https://ltm-ragnarok-tenants-prod-40455-webapp.s3.amazonaws.com/static/media/Banner_duvidas_pontos_mobile.png'

const ConexxeBanner = () => (
  <div className='bx-bannerConexxe pos-relative pb-2'>
    <div className='container px-0'>
      <div className='row mx-0'>
        <div className='col-12 px-1 px-sm-0 txt-center banner-tablet'>
          <Fragment>
            <MediaQuery maxDeviceWidth={475}>
              <a
                href='https://atendimentoiupp.zendesk.com/hc/pt-br'
                target='_blank'
                title='vai para atendimentoiupp'
              >
                <LazyLoadImage
                  src={ganhePontosMobile}
                  effect='blur'
                  alt='Tem alguma dúvida sobre o iupp? Confira a nossa página de perguntas e resposta ou nos mande uma mensagem.'
                  className='w-100'
                />
              </a>
            </MediaQuery>
            <MediaQuery minDeviceWidth={476}>
              <a
                href='https://atendimentoiupp.zendesk.com/hc/pt-br'
                target='_blank'
                title='vai para atendimentoiupp'
              >
                <LazyLoadImage
                  src={ganhePontos}
                  effect='blur'
                  alt='Tem alguma dúvida sobre o iupp? Confira a nossa página de perguntas e resposta ou nos mande uma mensagem.'
                  className='w-100'
                />
              </a>
            </MediaQuery>
          </Fragment>
        </div>
      </div>
    </div>
  </div>
)

export default ConexxeBanner



// WEBPACK FOOTER //
// ./src/features/Slider/ConexxeBanner.js